import { render, staticRenderFns } from "./wrappCard.vue?vue&type=template&id=43b0dcc2&"
import script from "./wrappCard.vue?vue&type=script&lang=js&"
export * from "./wrappCard.vue?vue&type=script&lang=js&"
import style0 from "./wrappCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports